<template>
  <v-snackbar
    v-model="recentNotification.snackbar"
    :timeout="recentNotification.delay"
    :color="recentNotification.type"
    :top="recentNotification.top"
    :bottom="recentNotification.bottom"
    :left="recentNotification.left"
    :right="recentNotification.right"
    :centered="recentNotification.centered"
  >
    <div class="snackbar-element">
      <v-icon>{{ recentNotification.icon }}</v-icon>
      <div class="snackbar-message">
        <h3>{{ recentNotification.message }}</h3>
        <div style="white-space: pre-line"
          v-if="recentNotification.description"
          >
          {{ recentNotification.description }}
        </div>
      </div>
    </div>
    <template v-slot:action="{ attrs }" v-if="recentNotification.dismissable">
      <v-btn text v-bind="attrs" @click="recentNotification.snackbar = false">
        Close
      </v-btn>
    </template>
    <!-- Comment -->
    <!-- <v-progress-linear
      absolute
      bottom
      :value="Math.floor(100 * (currentTime / recentNotification.delay))"
    /> -->
  </v-snackbar>
</template>

<script>
import notificationMixin from "@/_mixins/notification-mixin";
export default {
  name: "PopupNotifier",
  mixins: [notificationMixin],
  components: {},
  props: {},
  computed: {
    recentNotification() {
      return this.globalNotification.length > 0
        ? this.globalNotification[this.globalNotification.length - 1]
        : {};
    },
  },
  watch: {
    recentNotification(newVal, oldVal) {
      this.showNotification = true;
      var self = this;
      setTimeout(() => {
        self.showNotification = false;
      }, newVal.timeout);
    },
    globalNotification() {},
    value(v) {
      if (v) this.syncPbar();
    },
  },
  mounted() {
    //this.value = this.globalSnackbar;
  },
  data() {
    return {
      currentTime: 0,
      value: false,
      showNotification: true,
    };
  },
  methods: {
    syncPbar() {
      //Create a timeout every 100 miliseconds
      setTimeout(() => {
        //Increment the time counter by 100
        this.currentTime += 100;
        //If our current time is larger than the timeout
        if (this.recentNotification.delay && this.recentNotification.delay <= this.currentTime) {
          //Wait 500 miliseconds for the dom to catch up, then reset the snackbar
          setTimeout(() => {
            //this.globalSnackbar = false;
            this.currentTime = 0; // reset the current time
          }, 500);
        } else {
          //Recursivly update the progress bar
          this.syncPbar();
        }
      }, 100);
    },
    closeSnackbar() {
      this.showNotification = false;
    },
  },
};
</script>

<style scoped lang="scss">
.snackbar-element{
  display: flex;
  align-items: center;
  .v-icon{
    margin-right: 10px;
  }
  p{
    margin: 0px;
    margin-top: 5px;
  }
}
</style>
